import { Modal, ModalProps } from "react-bootstrap";
import { useThemeContext } from "../../components/theme/ThemeContext";
import styled from "styled-components";

const StyledModal = styled(Modal)`
  .modal-content {
    overflow: visible;
  }
`;

const ThemedModal = (props: ModalProps) => {
  const { theme } = useThemeContext();

  return (
    <StyledModal data-bs-theme={theme} {...props}>
      <div className="bg-light text-black">
        {props.children}
      </div>
    </StyledModal>
  );
};

export default ThemedModal;
